import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ApiService } from "../../../service/apiServices";
import Swal from "sweetalert2";
import { AuthService } from "../../../service/auth/auth.service";

@Component({
  selector: "app-certificate-aba",
  templateUrl: "./certificate.component.html",
  styleUrls: ["./certificate.component.css"],
})
export class CertificateComponent implements OnInit {
  @Output() retornoPost: EventEmitter<any> = new EventEmitter();
  @Input() presenca: any = {};
  @Input() prontuario: any = {};
  @Input() ListaAbaAtestado: any = [];
  @Input() atendimento: any;
  seeList: boolean = true;
  abrirModalAnexarDocumentoExterno: boolean = false;
  listaDeDocuemntos: any = [];
  documentos: any = [];
  tipo_documento: any = 2;


  visualizarListaDeclaracao: boolean = true;
  visualizarAbaLaudo: boolean = false;
  listaAbaDeclaracao: any = [];
  visualizar_prontuario: any = false;

  listaLaudos: any = [];


  constructor(public service: ApiService, private authService: AuthService) {
    this.authService.visualizarProntuario.subscribe((res) => {
      if (res) {
        this.visualizar_prontuario = res;
      }
    });
  }

  ngOnInit() {
    
  }

  goBack = () => {
    this.seeList = true;
  };

  goBackDeclaration = () => {
    this.visualizarListaDeclaracao = true;
    this.visualizarAbaLaudo = !this.visualizarAbaLaudo;   
  };

  retornoPostFilho = () => {
    this.retornoPost.emit();
  };

  carregarAbaDeclaracao() {
    
    this.listarDocumentosExternos(3);
    this.visualizarListaDeclaracao = true;
    this.obterListaDeclaracao();
  }
  carregarAbaLaudo(){

    this.listarDocumentosExternos(10);

    this.visualizarAbaLaudo = true;
    this.visualizarListaDeclaracao = false;

    this.listarLaudos();

  }
  listarLaudos(){
    
    this.service
      .Get(`Prontuario/${this.prontuario.id}/ProntuarioLaudo`)
      .then((result) => {
        this.listaLaudos = result;
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Erro",
          html: res.error.erros[0].messagem,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      });
    
  }

  obterListaDeclaracao = () => {
    Swal.fire("Favor aguarde");
    Swal.showLoading();
    this.service
      .Get(`Prontuario/${this.prontuario.id}/ProntuarioDeclaracao`)
      .then((result) => {
        this.listaAbaDeclaracao = result;
        Swal.close();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Erro",
          html: res.error.erros[0].messagem,
        }).then((result) => {
          if (result.isConfirmed) {
          }
        });
      });
  };

  onModalClose(): void {
    this.abrirModalAnexarDocumentoExterno = false;
    this.listarDocumentosExternos();
  }
  listarDocumentosExternos(tipo: number = 2) {    
    this.service
      .Get(
        `DocumentoExterno?atendimento_id=${this.atendimento.id}&cidadao_id=${this.atendimento.cidadao_id}`
      )
      .then(
        (result) => {
          const documentosExternos: { tipo_documento: number }[] = result as {
            tipo_documento: number;
          }[];

          this.documentos = documentosExternos.filter(
            (doc) => doc.tipo_documento === tipo
          );
          
        },
        (error) => {
          Swal.fire("Error", error.error.messagem, "error");
        }
      );
  }
  anexarDocumentoExterno() {
    this.abrirModalAnexarDocumentoExterno = true;
  }
}
